import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { T } from "@/i18n/translations";

const LangCtx = createContext({ lang: "en", setLang: () => {}, t: T.en });

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "en";
    const stored = window.localStorage.getItem("2t_lang");
    return stored === "fr" || stored === "en" ? stored : "en";
  });

  const setLang = (next) => {
    setLangState(next);
    try {
      window.localStorage.setItem("2t_lang", next);
    } catch {
      /* ignore */
    }
  };

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, t: T[lang] }), [lang]);
  return <LangCtx.Provider value={value}>{children}</LangCtx.Provider>;
};

export const useLang = () => useContext(LangCtx);
